
<div *ngIf="rewards">

  <div *ngIf="!editable && inline">

    <span class="text-muted">
      Rewards:
    </span>
    <span matTooltip="If you complete the task" class="ml-2">
      <fa-icon icon="circle-check"></fa-icon>
      {{rewards['COMPLETED']}}pts
    </span>
    <span class="text-negative ml-2" matTooltip="If you get poor feedback">
      <fa-icon icon="face-meh"></fa-icon>
      {{rewards['ASSESSED_POOR']}}pts
    </span>
    <span class="text-amber ml-2" matTooltip="If you get ok feedback">
      <fa-icon icon="face-smile"></fa-icon>
      {{rewards['ASSESSED_OK']}}pts
    </span>
    <span class="text-positive ml-2" matTooltip="If you get good feedback" >
      <fa-icon icon="face-grin-stars"></fa-icon>
      {{rewards['ASSESSED_GOOD']}}pts
    </span>

  </div>


  <table *ngIf="!editable && !inline">

    <tr>
      <td class="pr-3">
        <fa-icon icon="circle-check"></fa-icon>
      </td>
      <td class="px-1 text-right">
        <strong>{{rewards['COMPLETED']}}</strong> pts
      </td>
      <td class="text-left">
        if you <strong>complete the task</strong>
      </td>
    </tr>

    <tr class="text-positive">
      <td class="pr-3">
        <fa-icon icon="face-grin-stars"></fa-icon>
      </td>
      <td class="px-1 text-right">
        <strong>{{rewards['ASSESSED_GOOD']}}</strong> pts
      </td>
      <td class="text-left">
        if you get <strong>good</strong> feedback
      </td>
    </tr>

    <tr class="text-amber">
      <td class="pr-3">
        <fa-icon icon="face-smile"></fa-icon>
      </td>
      <td class="px-1 text-right">
        <strong>{{rewards['ASSESSED_OK']}}</strong> pts
      </td>
      <td class="text-left">
        if you get <strong>ok</strong> feedback
      </td>
    </tr>

    <tr class="text-negative">
      <td class="pr-3">
        <fa-icon icon="face-meh"></fa-icon>
      </td>
      <td class="px-1 text-right">
        <strong>{{rewards['ASSESSED_POOR']}}</strong> pts
      </td>
      <td class="text-left">
        if you get <strong>poor</strong> feedback
      </td>
    </tr>

  </table>

  <div *ngIf="editable">

    <div class="flex" [class]="(inline) ? 'flex-row gap-6':'flex-col'">

      <mat-form-field [class]="(inline) ? 'w-32':'w-full'" floatLabel="always">
        <mat-label *ngIf="!inline">For completing task</mat-label>
        <input matInput type="number" [(ngModel)]="rewards['COMPLETED']" name="completed" required (change)="handleRewardsChanged()"/>
        <span matPrefix class="px-3" matTooltip="For completing the task">
          <fa-icon icon="circle-check"></fa-icon>
        </span>
        <span matTextSuffix class="text-sm text-muted">pts</span>
      </mat-form-field>

      <mat-form-field [class]="(inline) ? 'w-32':'w-full'" floatLabel="always">
        <mat-label  *ngIf="!inline" class="text-negative">For poor feedback</mat-label>
        <input matInput type="number" [(ngModel)]="rewards['ASSESSED_POOR']" name="poor" required (change)="handleRewardsChanged()"/>
        <span matPrefix class="text-negative px-3" matTooltip="For receiving poor feedback">
          <fa-icon icon="face-meh"></fa-icon>
        </span>
        <span matTextSuffix class="text-sm text-muted">pts</span>
      </mat-form-field>

      <mat-form-field [class]="(inline) ? 'w-32':'w-full'" floatLabel="always">
        <mat-label *ngIf="!inline" class="text-amber">For ok feedback</mat-label>
        <input matInput type="number" [(ngModel)]="rewards['ASSESSED_OK']" name="ok" required (change)="handleRewardsChanged()"/>
        <span matPrefix class="text-amber px-3" matTooltip="For receiving ok feedback">
          <fa-icon icon="face-smile"></fa-icon>
        </span>
        <span matTextSuffix class="text-sm text-muted">pts</span>
      </mat-form-field>

      <mat-form-field [class]="(inline) ? 'w-32':'w-full'" floatLabel="always">
        <mat-label *ngIf="!inline" class="text-positive">For good feedback</mat-label>
        <input matInput type="number" [(ngModel)]="rewards['ASSESSED_GOOD']" name="good" required (change)="handleRewardsChanged()"/>
        <span matPrefix class="text-positive px-3" matTooltip="For receiving good feedback">
          <fa-icon icon="face-grin-stars"></fa-icon>
        </span>
        <span matTextSuffix class="text-sm text-muted">pts</span>
      </mat-form-field>
    </div>

  </div>


</div>

